import { HTTPResponse } from "@/types/app";
import { UploadResponse } from "@opp/shared";
import { storage } from "./storageService";

const API_URL = import.meta.env.VITE_API_URL;

export async function _prepareUpload(file: File, path: string, fileNameParam?: string): Promise<HTTPResponse<UploadResponse>> {
  const token = storage.get('token');
  if (!token) {
    throw new Error('TOKEN_NOT_FOUND');
  }

  const fileName = file.name;
  const fileExtension = fileName.split('.').pop();
  const newFileName = `${fileName}.${fileExtension}`;

  const signedUrl = await fetch(`${API_URL}/common/upload`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ file: fileNameParam ? fileNameParam : newFileName, type: file.type, path }),
  });

  if (!signedUrl.ok) {
    throw new Error('FAILED_TO_GET_SIGNED_URL');
  }

  return signedUrl.json();
}

export async function uploadFile(file: File, path: string, fileName?: string) {
  const { data: { url, key } } = await _prepareUpload(file, path, fileName);
  const response = await fetch(url, {
    method: 'PUT',
    body: file,
  });
  if (!response.ok) {
    throw new Error('FAILED_TO_UPLOAD_FILE');
  }
  return {
    file: key,
  };
}
